import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/nextjs/app/(app)/(paragraph)/dashboard/components/CollectorAvatars/wrapper.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostCardCollectButton"] */ "/vercel/path0/packages/nextjs/app/(app)/(paragraph)/home/components/PostCardComponents/PostCardCollectButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/nextjs/app/(landing)/components/CTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/nextjs/app/(landing)/components/FeaturedPublications.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/nextjs/app/(landing)/components/FeaturedPublicationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/nextjs/app/(landing)/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhyWriteSection"] */ "/vercel/path0/packages/nextjs/app/(landing)/components/WhyWrite.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/vercel/path0/packages/nextjs/components/sections/hero-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialsSection"] */ "/vercel/path0/packages/nextjs/components/sections/testimonials-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage"] */ "/vercel/path0/packages/nextjs/components/ui/avatar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/nextjs/components/ui/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel","CarouselPrevious","CarouselNext","CarouselContent","CarouselItem"] */ "/vercel/path0/packages/nextjs/components/ui/carousel.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/nextjs/public/publication/farcaster.png");
